export default __webpack_public_path__ + "static/media/adventure.587ce092.png";